import styled from 'styled-components';
import { getStyledFlatTabStyles } from './style';
import { StyledFlatTabProps } from './type';

const StyledFlatTab = styled.div<StyledFlatTabProps>(({ theme, borderBottomColor, borderBottomWidth, width }) =>
	getStyledFlatTabStyles({ theme, borderBottomColor, borderBottomWidth, width })
);

export default StyledFlatTab;
